<template>
  <div class="form-group row mb-4">
    <label class="col-lg-2" v-if="showTitle">
      {{ $t("departments.users.form.title") }}
    </label>
    <div class="col-lg-10" v-if="allUsers.length > 0">
      <b-table
        ref="selectableTable"
        :selectable="!readonly"
        :hover="!readonly"
        striped
        :select-mode="selectMode" 
        :items="allUsers"
        :fields="userFields"
        @row-selected="selectUser"
        responsive="sm"
        :class="{
          'users-table__table': true,
          valid: validateField(),
          invalid: validateField() === false
        }"
      >
      <template #cell(name)="user">
        {{user.item.lastName}}, {{user.item.firstName}}
      </template>
      <template v-slot:cell(userSelected)="{ rowSelected }">
        <template v-if="rowSelected">
          <span aria-hidden="true">&check;</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
        </template>
      </template>
      </b-table>
      <b-form-invalid-feedback :state="validateField()">
        {{ $t("validation.min-one") }}
      </b-form-invalid-feedback>
      <b-button size="sm" v-if="!readonly" @click="selectAllUsers">
        {{ $t("b-table.select-all") }}
        </b-button>
      <b-button size="sm" v-if="!readonly" @click="clearSelected">
        {{ $t("b-table.clear-all") }}
        </b-button>
    </div>
    <div class="col-lg-10" v-else>
      <label>
        <!-- TODO: add link/redirect to user-create page -->
        {{ $t("departments.users.form.no-users-found") }}
      </label>
    </div>
  </div>
</template>


<script>
import i18n from '@/i18n';
import { required } from "vuelidate/lib/validators";

export default {
  name: "UsersTable",
  props: {
    allUsers: {
      type: Array,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selectMode: this.getSelectMode(),
      chosenUsers: [],
      userFields: this.getUserFields(),
    };
  },
  validations: {
    chosenUsers: {
      required,
    },
  },
  methods: {
    validateField() {
      const { $dirty, $error } = this.$v.chosenUsers;
      return $dirty ? !$error : null;
    },
    selectUser(selectedRows) {
      this.$v.chosenUsers.$model = selectedRows;
      this.$emit("usersTableUpdate", {users: this.$v.chosenUsers.$model});
    },
    selectAllUsers() {
      this.clearSelected();
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    getSelectMode() {
      // A table with a single entry and "range" mode is not able to unselect the single row
      return this.allUsers.length > 2 ? "range" : "multi"; //single, multi, range
    },
    getUserFields() {
      const fields = [
        { key: "name", label: i18n.t("talents.overview.form.name") },
        { key: "telephone", label: i18n.t("talents.form.phone") },
      ];

      // Only show the "selected" row if table is not readonly
      if (!this.readonly) {
        fields.unshift({ key: "userSelected", label: i18n.t("talents.table.selected") });
      }

      return fields;
    }
  },
  
};
</script>

<style type="scss">
.users-table__table.valid {
  border: 1px solid #34c38f !important;
}

.users-table__table.invalid {
  border: 1px solid #f46a6a !important;
}
</style>
